import React from 'react';
import { BrutalButton } from './ui/BrutalButton';
import { Search, Database, Cpu, Share2 } from 'lucide-react';
export function Hero() {
  return <div className="h-screen flex flex-col bg-[#09090b] overflow-hidden" data-id="element-2">
      {/* Background Grid */}
      <div className="absolute inset-0 z-0 opacity-20 pointer-events-none" style={{
      backgroundImage: 'linear-gradient(#333 1px, transparent 1px), linear-gradient(90deg, #333 1px, transparent 1px)',
      backgroundSize: '40px 40px'
    }} data-id="element-3"></div>

      <main className="flex-1 flex flex-col items-center justify-center relative z-10 px-3 sm:px-4 md:px-6 lg:px-8 py-3 sm:py-4 overflow-hidden" data-id="element-4">
        {/* Main Container */}
        <div className="w-full max-w-7xl grid grid-cols-1 lg:grid-cols-12 gap-0 border-2 border-[#333] bg-[#09090b] max-h-full overflow-hidden" data-id="element-5">
          {/* Left Column: Content */}
          <div className="lg:col-span-7 p-3 sm:p-4 md:p-6 lg:p-8 xl:p-10 border-b-2 lg:border-b-0 lg:border-r-2 border-[#333] flex flex-col justify-center relative overflow-hidden" data-id="element-6">
            {/* Decorative Label */}
            <div className="absolute top-0 left-0 bg-[#ccff00] text-black text-[8px] sm:text-[10px] font-bold px-1.5 sm:px-2 py-0.5 sm:py-1" data-id="element-7">
              SYS.READY // V.2.0.4
            </div>

            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-extrabold leading-[0.9] tracking-tighter mb-2 sm:mb-3 md:mb-4 text-white mt-4 sm:mt-0" data-id="element-8">
              UNLOCK
              <br data-id="element-9" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#ccff00] to-white" style={{
              WebkitTextStroke: '1px #ccff00'
            }} data-id="element-10">
                INFINITE
              </span>
              <br data-id="element-11" />
              CREATIVITY
            </h1>

            <p className="text-[10px] sm:text-xs md:text-sm lg:text-base text-gray-400 mb-3 sm:mb-4 md:mb-6 max-w-lg leading-relaxed border-l-2 border-[#ccff00] pl-2 sm:pl-3 md:pl-4" data-id="element-12">
              Access the world's largest open-source database of high-fidelity
              AI prompts.
              <span className="text-[#ccff00] font-bold ml-1" data-id="element-13">
                &gt; 100+ verified entries.
              </span>
            </p>

            <div className="flex flex-col sm:flex-row gap-2 sm:gap-3" data-id="element-14">
              <BrutalButton className="text-[10px] sm:text-xs md:text-sm py-2 sm:py-2.5 px-3 sm:px-4" data-id="element-15">
                EXPLORE_DB
              </BrutalButton>
              <BrutalButton variant="outline" className="text-[10px] sm:text-xs md:text-sm py-2 sm:py-2.5 px-3 sm:px-4" data-id="element-16">
                SUBMIT_PROMPT
              </BrutalButton>
            </div>

            {/* Stats Bar */}
            <div className="mt-4 sm:mt-6 md:mt-8 grid grid-cols-2 gap-3 border-t border-[#333] pt-3 sm:pt-4" data-id="element-17">
              {[{
              label: 'ENTRIES',
              value: '100+'
            }, {
              label: 'USERS',
              value: '4K'
            }].map(stat => <div key={stat.label} data-id="element-18">
                  <div className="text-base sm:text-lg md:text-xl font-bold text-white" data-id="element-19">
                    {stat.value}
                  </div>
                  <div className="text-[8px] sm:text-[10px] text-[#ccff00]" data-id="element-20">
                    {stat.label}
                  </div>
                </div>)}
            </div>
          </div>

          {/* Right Column: Visual/Interactive - Hidden on very small screens */}
          <div className="hidden sm:flex lg:col-span-5 relative bg-[#111] flex-col overflow-hidden" data-id="element-21">
            {/* Search Simulation */}
            <div className="p-3 sm:p-4 md:p-5 border-b-2 border-[#333] bg-[#09090b]" data-id="element-22">
              <div className="flex items-center gap-1.5 mb-1.5 text-[8px] sm:text-[10px] text-gray-500" data-id="element-23">
                <Search size={10} data-id="element-24" /> SEARCH_QUERY
              </div>
              <div className="bg-black border border-[#333] p-2 sm:p-3 text-[#ccff00] font-bold flex items-center justify-between group cursor-pointer hover:border-[#ccff00] transition-colors text-[10px] sm:text-xs md:text-sm" data-id="element-25">
                <span className="truncate" data-id="element-26">"cyberpunk street food stall"</span>
                <span className="animate-pulse ml-2" data-id="element-27">_</span>
              </div>
            </div>

            {/* Prompt Cards Stack */}
            <div className="flex-1 p-3 sm:p-4 md:p-5 relative overflow-hidden" data-id="element-28">
              <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1620641788421-7a1c342ea42e?q=80&w=1000&auto=format&fit=crop')] bg-cover bg-center opacity-20 grayscale mix-blend-luminosity" data-id="element-29"></div>
              {/* Floating Card 1 */}
              <div className="relative z-10 bg-black border-2 border-white p-2 sm:p-3 md:p-4 mb-2 sm:mb-3 shadow-[3px_3px_0px_0px_#333] transform rotate-1 hover:rotate-0 transition-transform duration-300" data-id="element-30">
                <div className="flex justify-between items-start mb-1.5 sm:mb-2" data-id="element-31">
                  <div className="bg-[#ccff00] text-black text-[8px] sm:text-[10px] font-bold px-1 sm:px-1.5 py-0.5" data-id="element-32">
                    MIDJOURNEY V6
                  </div>
                  <Share2 size={12} className="text-gray-400" data-id="element-33" />
                </div>
                <p className="text-[8px] sm:text-[10px] md:text-xs text-gray-300 font-mono leading-relaxed line-clamp-2" data-id="element-34">
                  /imagine prompt: a futuristic brutalist skyscraper made of raw
                  concrete and neon lights...
                </p>
              </div>

              {/* Floating Card 2 */}
              <div className="relative z-10 bg-black border-2 border-[#ccff00] p-2 sm:p-3 md:p-4 ml-3 sm:ml-5 shadow-[3px_3px_0px_0px_#ccff00] transform -rotate-1 hover:rotate-0 transition-transform duration-300" data-id="element-35">
                <div className="flex justify-between items-start mb-1.5 sm:mb-2" data-id="element-36">
                  <div className="bg-white text-black text-[8px] sm:text-[10px] font-bold px-1 sm:px-1.5 py-0.5" data-id="element-37">
                    DALL-E 3
                  </div>
                  <Share2 size={12} className="text-gray-400" data-id="element-38" />
                </div>
                <p className="text-[8px] sm:text-[10px] md:text-xs text-gray-300 font-mono leading-relaxed line-clamp-2" data-id="element-39">
                  A detailed technical drawing of a mechanical eye, blueprint
                  style...
                </p>
              </div>
            </div>
            {/* Bottom Decoration */}
            <div className="p-2 sm:p-3 border-t-2 border-[#333] bg-[#ccff00] flex justify-between items-center" data-id="element-40">
              <div className="flex gap-2 text-black font-bold" data-id="element-41">
                <Database size={14} data-id="element-42" />
                <Cpu size={14} data-id="element-43" />
              </div>
              <div className="text-black font-bold text-[8px] sm:text-[10px] tracking-wider" data-id="element-44">
                EXPLORE_MORE
              </div>
            </div>
          </div>
        </div>
      </main>
      {/* Marquee Footer - Compact */}
      <div className="bg-white py-1.5 sm:py-2 border-y-2 border-black overflow-hidden whitespace-nowrap flex-shrink-0" data-id="element-45">
        <div className="inline-block animate-marquee" data-id="element-46">
          <span className="text-black font-black text-sm sm:text-base md:text-lg mx-2 sm:mx-3" data-id="element-47">
            LATEST_PROMPTS_ADDED
          </span>
          <span className="text-black font-black text-sm sm:text-base md:text-lg mx-2 sm:mx-3" data-id="element-48">
            {' '}
            ///
          </span>

          <span className="text-black font-black text-sm sm:text-base md:text-lg mx-2 sm:mx-3" data-id="element-49">
            STABLE_DIFFUSION_XL
          </span>
          <span className="text-black font-black text-sm sm:text-base md:text-lg mx-2 sm:mx-3" data-id="element-50">
            {' '}
            ///
          </span>

          <span className="text-black font-black text-sm sm:text-base md:text-lg mx-2 sm:mx-3" data-id="element-51">
            GPT-4_SYSTEM_PROMPTS
          </span>
          <span className="text-black font-black text-sm sm:text-base md:text-lg mx-2 sm:mx-3" data-id="element-52">
            {' '}
            ///
          </span>

          <span className="text-black font-black text-sm sm:text-base md:text-lg mx-2 sm:mx-3" data-id="element-53">
            LATEST_PROMPTS_ADDED
          </span>
          <span className="text-black font-black text-sm sm:text-base md:text-lg mx-2 sm:mx-3" data-id="element-54">
            {' '}
            ///
          </span>

          <span className="text-black font-black text-sm sm:text-base md:text-lg mx-2 sm:mx-3" data-id="element-55">
            STABLE_DIFFUSION_XL
          </span>
          <span className="text-black font-black text-sm sm:text-base md:text-lg mx-2 sm:mx-3" data-id="element-56">
            {' '}
            ///
          </span>

          <span className="text-black font-black text-sm sm:text-base md:text-lg mx-2 sm:mx-3" data-id="element-57">
            GPT-4_SYSTEM_PROMPTS
          </span>
          <span className="text-black font-black text-sm sm:text-base md:text-lg mx-2 sm:mx-3" data-id="element-58">
            {' '}
            ///
          </span>
        </div>
      </div>
      <style data-id="element-59">{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          animation: marquee 20s linear infinite;
        }
      `}</style>
    </div>;
}